import { ChevronRight } from 'lucide-react';
import type { ReactNode } from 'react';
import { Link } from 'react-router';
import { cn } from '@/lib/cn';

/**
 * Números do drill-down (T-144c, RF-37; DEC-058) com cara de link mesmo sem o mouse (WCAG 1.4.1 — não só pela cor):
 * o número grande sublinhado pontilhado; o selo de semáforo com a seta ao lado.
 */
export const DRILL_NUMBER =
  'underline decoration-dotted decoration-2 underline-offset-4 hover:decoration-solid focus-visible:decoration-solid';

/** Selo (semáforo com o número) que leva ao nível de baixo. */
export function DrillBadgeLink({
  to,
  label,
  className,
  children,
}: {
  to: string;
  /** O que o link faz, para leitores de tela (ex.: "K1 82%: ver por unidade"). */
  label: string;
  className?: string;
  children: ReactNode;
}) {
  return (
    <Link
      to={to}
      aria-label={label}
      className={cn(
        'inline-flex items-center gap-0.5 rounded-full hover:ring-2 hover:ring-ring/40 focus-visible:ring-2 focus-visible:ring-ring/60',
        className,
      )}
    >
      {children}
      <ChevronRight aria-hidden className="size-3.5 shrink-0 text-muted-foreground" />
    </Link>
  );
}

/** Número solto (ex.: % numa linha de lista) que leva ao nível de baixo. */
export function DrillValueLink({ to, label, children }: { to: string; label: string; children: ReactNode }) {
  return (
    <Link
      to={to}
      aria-label={label}
      className={cn('inline-flex shrink-0 items-center gap-0.5 font-bold tabular-nums', DRILL_NUMBER)}
    >
      {children}
      <ChevronRight aria-hidden className="size-3.5 shrink-0 text-muted-foreground" />
    </Link>
  );
}
